import { ecss } from '@signal/theme/emotion'
import { keyframes } from '@emotion/react'

export const fadeInUpKeyframe = keyframes`
  0% {
    opacity:0;
    transform: translateY(20px);
   }

  100% {
    opacity: 1;
  }
`

const fadeInUpAnimation = ecss`
  animation: ${fadeInUpKeyframe} 300ms ease-out;
`
export default fadeInUpAnimation
